export const getReqFees = (offer: any) => {
  if (!offer.feesset) return 0
  const fees = offer.feesset
    .filter((fee: any) => !fee.required)
    .reduce((total: number, fee: any) => total + (isNaN(fee.amount) ? 0 : fee.amount), 0)
  return Number(fees.toFixed(2))
}
